import { legacyPlugins } from "/home/runner/_work/mono/mono/out/node_modules/.pnpm/@unhead+vue@3.4.2_esbuild@0.24.0_rolldown@1.2.13_vite@8.3.4_vue@3.5.43/node_modules/@unhead/vue/dist/legacy.mjs";
export default {
  disableDefaults: true,
  plugins: legacyPlugins,
}